interface IFeatureFlag {
  isEnabled: boolean; // flag is enabled
  organizationIds: Array<number>; // if entry exists, is enabled for only the provided organization
  // accounts: Array<string> // if entry exists, is enabled for only the provided accounts (not supported until we can get a good way to manage switching accounts)
}

export interface IFeatureFlags {
  AdHoc: IFeatureFlag;
}

const prodFlags: IFeatureFlags = {
  AdHoc: {
    isEnabled: true,
    organizationIds: [281],
  },
};

const qaFlags: IFeatureFlags = {
  AdHoc: {
    isEnabled: true,
    organizationIds: [273, 378, 379, 380],
  },
};

export const flags: IFeatureFlags = import.meta.env.PROD ? prodFlags : qaFlags;

export type FeatureFlagKey = keyof IFeatureFlags;
